export default "__VITE_ASSET__nxIAMuf3__"